import type { IFup, IFupPartnerFeedback } from "@bbj-types/socialApply/fup";
import { useCallback } from "react";
import { axios } from "../axios";

export type TFupPdf = Omit<IFup, "partner" | "partnerFeedback"> & {
  partnerFeedback?: Partial<IFupPartnerFeedback>;
};

export const usePreviewFup = () => {
  const [state, execute, cancel] = axios<string, TFupPdf, unknown>(
    {
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: TFupPdf) => {
      return execute({
        url: "/applies/social/fup/previewPdf",
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
